import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoradadmdadosfaturamentounidata(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoradadmdadosfaturamentounidata/FIND_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradadmdadosfaturamentounidata/UPDATE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradadmdadosfaturamentounidata/DELETE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradadmdadosfaturamentounidata/STORE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradadmdadosfaturamentounidata/RADPESQUISAPREFATURAUNIDATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoradadmdadosfaturamentounidata/SUCCESS_REMOVE':
      case '@operacaoradadmdadosfaturamentounidata/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoradadmdadosfaturamentounidata/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoradadmdadosfaturamentounidata;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoradadmdadosfaturamentounidata/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoradadmdadosfaturamentounidata;
        break;
      }

      case '@operacaoradadmdadosfaturamentounidata/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
